// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { MedicalBluetoothService } from "../services/medical-bluetooth/medical-bluetooth.service";
import { ACTION_STATUS_ENTITY, IEntity, Reference, STATUS_ENTITY } from "./sharedInterfaces";

export enum NOTIFICATION_TYPE {
  DRUG = 1,
  APPOINTMENT = 2,
  OBSERVATION = 3,
  FEELING = 4,
  ADVICE = 5,
  ALERT_OBSERVATION = 6,
  RELATED_APPOINTMENT = 7,
  RELATED_DRUG = 8,
  ACTIVITY = 9,
}

/**
 * Local notification system status
 */
export enum NOTIFICATION_SYSTEM_STATUS {
  SCHEDULED = 0, // notification has been planned but not yet triggered (default)
  TRIGGERED = 1, // notification has triggered
  CLEARED = 2, // notification has been cleared
}

/**
 * notification app status
 */
export enum NOTIFICATION_STATUS {
  MYSTERY = -1, // Do not use this enum value, a notification status was set to -1 in the past (agenda.page.ts) but we can't remember why
  NONE = 0, // user has done nothing yet with this notification
  ACCEPTED = 1, // user has accepted the notification (drug has been taken)
  REJECTED = 2, // user has rejected the notification (drug has NOT been taken)
  DELETED = 3, // user has deleted the notification (for unscheduled intakes)
}

export interface IDeviceNotification {
  reference: string;
  type: MedicalBluetoothService;
  address: string;
}

export interface INotification extends IEntity {
  account: string; // account owner
  systemId?: number; // internal system id
  appId?: string; // application item id (activity._id, appointment._id, etc.)
  active?: boolean; // activated or not by user
  ntype?: NOTIFICATION_TYPE; // type
  message?: string; // notification message
  time?: string; // time for action to be done by user
  trigger?: any;
  at?: string; // time to launch notification (may be earlier/later than effective time)
  start?: string; // start period
  end?: string; // end period
  systemStatus?: NOTIFICATION_SYSTEM_STATUS; // local notifcation status
  status?: NOTIFICATION_STATUS; // notification app status
  comment?: string; //  comment for rejected status
  moment?: string; // (matin, midi, soir...)
  related?: Reference; // related patient reference
  reference?: any;
  source?: string;
  hasDisplay: boolean; // something in display
  display?: string; // display photo drug when needed (volatile info, not stored in DB)
  color?: string;
  datas?: any;
  identifierAlert?: string; // identifier of the associated alert (if necessary)
  language?: string;
  drugComment?: string;
  device?: IDeviceNotification;
  deviceUsageIds?: { usageId: string; address: string }[];
  unscheduledIntake?: boolean;
  author?: Reference;
  quantity?: string;
  quantityTaken?: string;
}

/**
 * Class to handler Local Notification data
 *
 * _ID field is used to handle server storage. It is not set until modification
 * is done on notification (mainly when drug taken or not)
 *
 */
export class Notification implements INotification {
  // public account: string;
  public systemId: number; // id of the LocalNotification plugin
  // public appId: string;       // application item id (activity._id, appointment._id, etc.)
  public active: boolean; // activated or not by user
  // public type: NOTIFICATION_TYPE; // type
  public message: string; // notification message
  public time: string; // time for action to be done by user
  public trigger: any; // frequency to schedule (base on locale notification plugin "trigger" field)
  public at: string; // time to launch notification (may be earlier/later than effective time)
  // public start: string;       // start period
  // public end: string;         // end period
  public systemStatus: NOTIFICATION_SYSTEM_STATUS; // local notifcation status
  public status: NOTIFICATION_STATUS; // notification app status
  public comment: string; //  comment for rejected status
  public hasDisplay: boolean; // something in display
  public display?: string; // display photo drug when needed (volatile info, not stored in DB)
  public related?: Reference; // related patient reference
  public color?: string; // to colorize background of the notification in homepage
  public reference?: any; // Notification reference to an object / action / entity / ...

  public _id: string;
  public creation?: string;
  public modified: string;
  public actionStatus?: ACTION_STATUS_ENTITY;
  public entityStatus: STATUS_ENTITY[];
  public datas?: any;
  public isLong?: boolean; // Advice long or not
  public language?: string;
  public drugComment?: string;
  public moment?: string; // (matin, midi, soir...)
  public unscheduledIntake?: boolean;
  public device?: IDeviceNotification;
  public deviceUsageIds?: { usageId: string; address: string }[];
  public quantity?: string;
  public quantityTaken?: string;

  constructor(
    public account: string,
    public ntype: NOTIFICATION_TYPE,
    public start: string,
    public end: string,
    public appId: string,
    public source: string = "", // indicates where the notification has created (for example AppConstants.NOTIF_SOURCE_ALERT()) ; if empty, default notification
    public identifierAlert: string = null
  ) {
    this.active = true;
    this.systemId = 0;
    this.trigger = null;
    this.systemStatus = NOTIFICATION_SYSTEM_STATUS.SCHEDULED;
    this.status = NOTIFICATION_STATUS.NONE;
    this.entityStatus = [STATUS_ENTITY.ACTIVE];
    this.actionStatus = ACTION_STATUS_ENTITY.CREATED;
    this.hasDisplay = false;
  }
}
